const PAYMENTS_FUNCTION_URL =
  process.env.REACT_APP_PAYMENTS_FUNCTION_URL ||
  'https://europe-west1-vinogenes-5207a.cloudfunctions.net/createPaymentIntent';

function parsePaymentError(status, data, fallback) {
  if (data?.error && typeof data.error === 'string') {
    return data.error;
  }
  if (data?.message && typeof data.message === 'string') {
    return data.message;
  }
  if (status === 403) {
    return 'Acceso denegado al servidor de pagos. Recarga la página e inténtalo de nuevo.';
  }
  if (status === 404) {
    return 'El servicio de pagos no está disponible. Contacta con la tienda.';
  }
  return fallback;
}

async function createPaymentIntentViaHttp(amountCents, metadata = {}) {
  const response = await fetch(PAYMENTS_FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount: amountCents,
      currency: 'eur',
      metadata
    })
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      parsePaymentError(
        response.status,
        data,
        'Error al conectar con el servidor de pagos'
      )
    );
  }

  if (!data.clientSecret || !data.paymentIntentId) {
    throw new Error('Respuesta inválida del servidor de pagos');
  }

  return {
    clientSecret: data.clientSecret,
    paymentIntentId: data.paymentIntentId,
    devMode: false
  };
}

/**
 * Crea un PaymentIntent vía Cloud Function + Stripe.
 */
export async function createPaymentIntent(amountCents, metadata = {}) {
  if (process.env.NODE_ENV === 'development') {
    try {
      return await createPaymentIntentViaHttp(amountCents, metadata);
    } catch (error) {
      console.warn('Pagos en modo desarrollo (sin cobro real):', error.message);
      return {
        clientSecret: null,
        paymentIntentId: `pi_dev_${Date.now()}`,
        devMode: true
      };
    }
  }

  return createPaymentIntentViaHttp(amountCents, metadata);
}

export function eurosToCents(euros) {
  return Math.round(euros * 100);
}
